import { h, render } from "preact";

export default function ModelSelector({
  compareProduct,
  index,
  products,
  setCompareProduct,
}) {
  return (
    <div className="compare-modal-v2__row-item">
      <select
        className="compare-modal-v2__model-select"
        onChange={(e) => {
          setCompareProduct(e.target.value, index);
        }}
        value={compareProduct.product.id}
      >
        {products.map(({ product }) => (
          <option value={product.id}>{product.title}</option>
        ))}
      </select>
    </div>
  );
}
